import React from "react";
import { IconType } from "@/types/utils";

const DeleteIcon: IconType = ({ size, ...otherProps }) => (
  <svg
    width={size || "24"}
    height={size || "24"}
    {...otherProps}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_9030)">
      <path
        d="M14.1667 4.99984H18.3334V6.6665H16.6667V17.4998C16.6667 17.7209 16.579 17.9328 16.4227 18.0891C16.2664 18.2454 16.0544 18.3332 15.8334 18.3332H4.16675C3.94573 18.3332 3.73377 18.2454 3.57749 18.0891C3.42121 17.9328 3.33341 17.7209 3.33341 17.4998V6.6665H1.66675V4.99984H5.83342V2.49984C5.83342 2.27882 5.92121 2.06686 6.07749 1.91058C6.23377 1.7543 6.44573 1.6665 6.66675 1.6665H13.3334C13.5544 1.6665 13.7664 1.7543 13.9227 1.91058C14.079 2.06686 14.1667 2.27882 14.1667 2.49984V4.99984ZM15.0001 6.6665H5.00008V16.6665H15.0001V6.6665ZM7.50008 9.1665H9.16675V14.1665H7.50008V9.1665ZM10.8334 9.1665H12.5001V14.1665H10.8334V9.1665ZM7.50008 3.33317V4.99984H12.5001V3.33317H7.50008Z"
        fill="red"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_9030">
        <rect width="20" height="20" stroke="transparent" strokeWidth="1" />
      </clipPath>
    </defs>
  </svg>
);

export default DeleteIcon;
